module.exports = __webpack_public_path__ + "static/media/oxo-5qt.743ca651.jpg";